import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import React from 'react'


function convertirARomano(numero) {
    const romanos = [
        { valor: 10, simbolo: "X" },
        { valor: 9, simbolo: "IX" },
        { valor: 5, simbolo: "V" },
        { valor: 4, simbolo: "IV" },
        { valor: 1, simbolo: "I" },
    ];

    let resultado = "";
    for (const { valor, simbolo } of romanos) {
        while (numero >= valor) {
            resultado += simbolo;
            numero -= valor;
        }
    }

    return resultado;
}


export default function SolicitudTables({ data }) {
    let {
        tipo: { nombre },
        semestre,
        estado_actual,
        sigla,
        usuario_registro: { primer_nombre, segundo_nombre, primer_apellido, segundo_apellido },
    } = data;
    const semestreRomano = convertirARomano(semestre);

    return (
        <Table>
            <TableBody>
                    <TableRow key={2}>
                        <TableCell component="th" scope="row">Solicitante</TableCell>
                        <TableCell align="left">
                            {`${primer_nombre || ''} ${segundo_nombre || ''} ${primer_apellido || ''} ${segundo_apellido || ''}`.trim()}
                        </TableCell>
                    </TableRow>
                <TableRow key={2}>
                    <TableCell component="th" scope="row">Tipo de solicitud</TableCell>
                    <TableCell align="left">{nombre}</TableCell>
                </TableRow>
                <TableRow key={3}>
                    <TableCell component="th" scope="row">Semestre</TableCell>
                    <TableCell align="left">{semestreRomano}</TableCell>
                </TableRow>
                <TableRow key={4}>
                    <TableCell component="th" scope="row">Estado Actual</TableCell>
                    <TableCell align="left">{estado_actual.nombre}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
}

export function DetalleCurso({ datos }) {

    // const classes = useStyles();
    const dato = datos[0];
    const esSolicitudCompleta = dato.horario;
    const semestreRomano = convertirARomano(dato.semestre);

    if (esSolicitudCompleta) {
        const {
        solicitud: { tipo, periodo,  nombrecompleto_tutorlegal,
            numeroidentificacion_tutorlegal,
            PermisoTutor },
        usuario_registro: { primer_nombre, segundo_nombre, primer_apellido, segundo_apellido },
        semestre,
        horario,
        programa,
        semillero,
    } = dato;
    const semestreRomano = convertirARomano(semestre);

    return (
        <Table>
            <TableBody>
                <TableRow key={1}>
                    <TableCell component="th" scope="row">Tipo de solicitud</TableCell>
                    <TableCell align="left">{tipo.nombre}</TableCell>
                </TableRow>
                <TableRow key={2}>
                    <TableCell component="th" scope="row">Solicitante</TableCell>
                    <TableCell align="left">{`${primer_nombre} ${segundo_nombre || ''} ${primer_apellido} ${segundo_apellido || ''}`}</TableCell>
                </TableRow>
                <TableRow key={3}>
                    <TableCell component="th" scope="row">Semestre</TableCell>
                    <TableCell align="left">{semestreRomano}</TableCell>
                </TableRow>
                <TableRow key={4}>
                    <TableCell component="th" scope="row">Periodo</TableCell>
                    <TableCell align="left">{periodo}</TableCell>
                </TableRow>
                <TableRow key={5}>
                    <TableCell component="th" scope="row">Horario</TableCell>
                    <TableCell align="left">{horario}</TableCell>
                </TableRow>
                <TableRow key={6}>
                    <TableCell component="th" scope="row">Programa</TableCell>
                    <TableCell align="left">{programa.nombre}</TableCell>
                </TableRow>
                {nombrecompleto_tutorlegal &&
                    <TableRow key={1}>
                    <TableCell component="th" scope="row">Nombre del tutor legal</TableCell>
                    <TableCell align="left">{nombrecompleto_tutorlegal}</TableCell>
                    </TableRow>  
                    }
                    {numeroidentificacion_tutorlegal &&
                    <TableRow key={1}>
                    <TableCell component="th" scope="row">Número de identificación del tutor legal</TableCell>
                    <TableCell align="left">{numeroidentificacion_tutorlegal}</TableCell>
                    </TableRow> }
                    {PermisoTutor && (
                    <TableRow key={1}>
                    <TableCell component="th" scope="row">Autorización del tutor legal</TableCell>
                    <TableCell align="left">{PermisoTutor}</TableCell>
                    </TableRow>
                    ) }
                {
                    semillero !== null &&
                    <TableRow key={7}>
                        <TableCell component="th" scope="row">Semillero al que se encuentra vinculado</TableCell>
                        <TableCell align="left">{semillero.nombre}</TableCell>
                    </TableRow>
                }
                {/* <TableRow key={7}>
                    <TableCell component="th" scope="row">
                        Semillero al que pertenece
                    </TableCell>
                    <TableCell align="left">
                        <TableRow scope="row">{"Nombre: " + semillero.nombre}</TableRow>
                        <TableRow scope="row">{"Sigla: " + semillero.sigla}</TableRow>
                    </TableCell>
                </TableRow> */}
            </TableBody>
        </Table>
    );
    } else {
        const {
            solicitud: { periodo},
            tipo_adjunto,
            usuario_registro: { primer_nombre, segundo_nombre, primer_apellido, segundo_apellido, correo},
            numero,
            programa,
        } = dato;

        return (
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell component="th">Tipo de solicitud</TableCell>
                        <TableCell align="left">{tipo_adjunto?.nombre || ''}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th">Solicitante</TableCell>
                        <TableCell align="left">{`${primer_nombre} ${segundo_nombre || ''} ${primer_apellido} ${segundo_apellido || ''}`}</TableCell>
                        </TableRow>
                    <TableRow>
                        <TableCell component="th">Semestre</TableCell>
                        <TableCell align="left">{semestreRomano}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th">Periodo</TableCell>
                        <TableCell align="left">{periodo}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th">Programa</TableCell>
                        <TableCell align="left">{programa.nombre}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th">Correo</TableCell>
                        <TableCell align="left">{correo}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th">Teléfono</TableCell>
                        <TableCell align="left">{numero}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }
}
